import { useMemo } from "react";
import AssetGallery, {
  ASSET_TYPE_IMAGE,
  ASSET_TYPE_VIDEO
} from "template-store/components/asset-gallery/asset-gallery";
import TemplateBenefits from "template-store/components/template-benefits/template-benefits";
import TemplateLongDescription from "template-store/components/template-long-description/template-long-description";
import { componentStyles } from "./template-overview-content.scss";

const TemplateOverviewContent = (props) => {
  const { templateData } = props;
  const { images, videoLink, longDescription } = templateData;

  const assetsList = useMemo(() => {
    const list = images.map((imageData) => {
      return { src: imageData.url, title: imageData.title, type: ASSET_TYPE_IMAGE };
    });

    if (videoLink) {
      list.splice(1, 0, { src: videoLink, type: ASSET_TYPE_VIDEO }); //currently we always put the video as the 2nd item
    }

    return list;
  }, [images, videoLink]);

  return (
    <div className="template-overview-content">
      <div className="images-wrapper">
        <AssetGallery assets={assetsList} />
      </div>
      <div className="template-benefits-wrapper">
        <TemplateBenefits benefits={templateData?.benefits} />
      </div>
      {longDescription && <div className="template-long-description-wrapper">
        <hr className="template-long-description-divider"></hr>
        <TemplateLongDescription descriptions={longDescription} />
      </div>}
      <style jsx>{componentStyles}</style>
    </div>
  );
};

export default TemplateOverviewContent;
